import * as types from "../../actions/actionTypes";

const initialState = {
  listLoading: true,
  listError: "",
  listData: [],
  listMeta: {},

  initLoading: true,
  initError: "",
  initData: {},

  processing: false,
  last_item: {},

  showData: {},
  showLoading: true,
  showError: "",

  data: {},
  loading: true,
  error: "",

  removeProcessing: false
};

const ManagerPettyCashBudget = (state = initialState, action) => {
  switch (action.type) {
    case types.MANAGER_GET_LIST_PETTY_CASH_BUDGET_REQUEST:
      return {
        ...state,
        listLoading: true,
        listError: "",
        listData: [],
        listMeta: {}
      };
    case types.MANAGER_GET_LIST_PETTY_CASH_BUDGET_SUCCESS:
      return {
        ...state,
        listData: action.payLoad.data,
        listMeta: action.payLoad.meta,
        listLoading: false
      };
    case types.MANAGER_GET_LIST_PETTY_CASH_BUDGET_FAILURE:
      return { ...state, listLoading: false, listError: action.error };

    case types.MANAGER_GET_INIT_PETTY_CASH_BUDGET_REQUEST:
      return { ...state, initLoading: true, initError: "", initData: {} };
    case types.MANAGER_GET_INIT_PETTY_CASH_BUDGET_SUCCESS:
      return {
        ...state,
        initData: action.payLoad,
        initLoading: false
      };
    case types.MANAGER_GET_INIT_PETTY_CASH_BUDGET_FAILURE:
      return { ...state, initLoading: false, initError: action.error };

    case types.MANAGER_EMPTY_PETTY_CASH_BUDGET_CACHED_DATA_FOR_CREATE:
      return { ...state, initData: {}, showData: {} };

    case types.MANAGER_STORE_PETTY_CASH_BUDGET_REQUEST:
      return { ...state, processing: true };
    case types.MANAGER_STORE_PETTY_CASH_BUDGET_SUCCESS:
      return {
        ...state,
        last_item: action.payLoad,
        processing: false
      };
    case types.MANAGER_STORE_PETTY_CASH_BUDGET_FAILURE:
      return { ...state, processing: false };

    case types.MANAGER_SHOW_PETTY_CASH_BUDGET_REQUEST:
      return { ...state, showLoading: true, showError: "" };
    case types.MANAGER_SHOW_PETTY_CASH_BUDGET_SUCCESS:
      return {
        ...state,
        showData: action.payLoad,
        showLoading: false
      };
    case types.MANAGER_SHOW_PETTY_CASH_BUDGET_FAILURE:
      return { ...state, showLoading: false, showError: action.error };

    case types.MANAGER_GET_PETTY_CASH_BUDGET_REQUEST:
      return { ...state, loading: true, error: "" };
    case types.MANAGER_GET_PETTY_CASH_BUDGET_SUCCESS:
      return {
        ...state,
        data: action.payLoad,
        loading: false
      };
    case types.MANAGER_GET_PETTY_CASH_BUDGET_FAILURE:
      return { ...state, loading: false, error: action.error };

    case types.MANAGER_UPDATE_PETTY_CASH_BUDGET_REQUEST:
      return { ...state, processing: true };
    case types.MANAGER_UPDATE_PETTY_CASH_BUDGET_SUCCESS:
      return {
        ...state,
        last_item: action.payLoad,
        showData: action.payLoad,
        processing: false
      };
    case types.MANAGER_UPDATE_PETTY_CASH_BUDGET_FAILURE:
      return { ...state, processing: false };

    case types.MANAGER_REMOVE_PETTY_CASH_BUDGET_REQUEST:
      return { ...state, removeProcessing: true };
    case types.MANAGER_REMOVE_PETTY_CASH_BUDGET_SUCCESS:
      return {
        ...state,
        removeProcessing: false
      };
    case types.MANAGER_REMOVE_PETTY_CASH_BUDGET_FAILURE:
      return { ...state, removeProcessing: false };

    default:
      return state;
  }
};

export default ManagerPettyCashBudget;
